import { Button } from '@/components/ui/button';
import { useTheme } from '@/hooks/use-theme';
import { Moon, Sun } from 'lucide-react';

/**
 * Toggle rápido de tema no Topbar. Click alterna light ↔ dark direto (não
 * passa por 'system'). Se theme atual = 'system', usa o resolved (light/dark
 * efetivo) pra decidir pra onde alternar.
 *
 * Pra fine-tune (escolher 'system'), user vai em /account/profile que tem
 * o Select com 3 opções.
 */
export function ThemeToggle() {
  const { resolved, setTheme } = useTheme();
  const next = resolved === 'dark' ? 'light' : 'dark';
  const Icon = resolved === 'dark' ? Sun : Moon;
  return (
    <Button
      variant="ghost"
      size="icon"
      className="h-8 w-8"
      onClick={() => setTheme(next)}
      aria-label={resolved === 'dark' ? 'Mudar para tema claro' : 'Mudar para tema escuro'}
      title={resolved === 'dark' ? 'Tema claro' : 'Tema escuro'}
    >
      <Icon className="h-4 w-4" />
    </Button>
  );
}
